import { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import API from '../utils/API';
import './ambassador.css';

export default function AmbassadorPage() {
  const [referralToken, setReferralToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);
  const [toEmail, setToEmail] = useState('');
  const [toName, setToName] = useState('');
  const [sending, setSending] = useState(false);
  const [inviteStatus, setInviteStatus] = useState(null);

  useEffect(() => {
    API.getMyAmbassadorInfo()
      .then(res => setReferralToken(res.data.referral_token))
      .catch(() => setReferralToken(null))
      .finally(() => setLoading(false));
  }, []);

  const referralLink = referralToken ? `${window.location.origin}/join/${referralToken}` : '';

  const handleCopy = () => {
    if (!referralLink) return;
    navigator.clipboard.writeText(referralLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleSendInvite = (e) => {
    e.preventDefault();
    if (!toEmail.trim()) return;
    setSending(true);
    setInviteStatus(null);
    API.sendAmbassadorInvite({ to_email: toEmail.trim(), to_name: toName.trim() })
      .then(() => {
        setInviteStatus({ type: 'success', message: `Invite sent to ${toEmail.trim()}.` });
        setToEmail('');
        setToName('');
      })
      .catch(err => {
        setInviteStatus({ type: 'error', message: err.response?.data?.msg || 'Failed to send invite. Please try again.' });
      })
      .finally(() => setSending(false));
  };

  if (loading) {
    return (
      <div className="ambassador-page">
        <div className="ambassador-header">
          <p className="ambassador-tagline">Loading your Ambassador info…</p>
        </div>
      </div>
    );
  }

  if (!referralToken) {
    return (
      <div className="ambassador-page">
        <div className="ambassador-header">
          <h1 className="ambassador-title">Ambassador</h1>
          <p className="ambassador-tagline">You don't currently have Ambassador access.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ambassador-page">
      <div className="ambassador-header">
        <h1 className="ambassador-title">Ambassador</h1>
        <p className="ambassador-tagline">Share your link to earn commission when people you refer subscribe.</p>
      </div>

      <div className="ambassador-card">
        <div className="ambassador-card-title">Your referral link</div>
        <div className="ambassador-qr-wrap">
          <div className="ambassador-qr-box">
            <QRCodeSVG value={referralLink} size={128} />
          </div>
          <div className="ambassador-link-group">
            <div className="ambassador-link-label">Anyone who subscribes through this link or code is credited to you.</div>
            <div className="ambassador-link-row">
              <input className="ambassador-link-input" type="text" readOnly value={referralLink} onFocus={(e) => e.target.select()} />
              <button className="ambassador-copy-btn" onClick={handleCopy}>
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="ambassador-card">
        <div className="ambassador-card-title">Send a subscription invite</div>
        <form onSubmit={handleSendInvite}>
          <div className="ambassador-form-row">
            <input
              type="email"
              placeholder="Their email address"
              value={toEmail}
              onChange={(e) => setToEmail(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Their name (optional)"
              value={toName}
              onChange={(e) => setToName(e.target.value)}
            />
          </div>
          <button className="ambassador-invite-btn" type="submit" disabled={sending}>
            {sending ? 'Sending…' : 'Send Invite'}
          </button>
          {inviteStatus && (
            <div className={`ambassador-invite-status ambassador-invite-status--${inviteStatus.type}`}>
              {inviteStatus.message}
            </div>
          )}
        </form>
      </div>

      <p className="ambassador-info-note">
        Commissions are credited automatically once your referral's subscription is confirmed. Payouts are handled manually — reach out with any questions about your balance or payment schedule.
      </p>
    </div>
  );
}
